import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/purchaseHistorical/${dossierId}/economicPlan`, method: 'GET', token: token })
}
